<div class="flex w-full h-full gap-8">
  @if (iosScreenshot$ | async) {
    <div class="w-fit screenshot-container mb-6">
      <svg
        class="w-full h-full"
        viewBox="0 0 292 616"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <clipPath id="phone-clip">
            <rect x="8" y="8" width="276" height="600" rx="40" />
          </clipPath>
        </defs>
        <rect
          x="4"
          y="4"
          width="284"
          height="608"
          rx="44"
          stroke="black"
          stroke-width="8"
        />
        <image
          [attr.xlink:href]="iosScreenshot$ | async"
          x="8"
          y="8"
          width="276"
          height="600"
          preserveAspectRatio="xMidYMid slice"
          clip-path="url(#phone-clip)"
        />
        <rect x="107" y="16" width="77" height="22" rx="11" fill="black" />
      </svg>
    </div>
  }
  <div class="flex-2 h-full w-full flex flex-col justify-center pb-6">
    <h3 class="text-2xl font-bold mb-[10px]">{{ 'ios-screenshot.title' | translate }}</h3>
    <p class="opacity-70 mb-[10px]" [innerHTML]="'ios-screenshot.desc' | translate"></p>
    @if (appStoreLink$ | async; as link) {
      <rk-button
        (buttonClick)="window.open(link, '_blank')"
        [text]="'global.share' | translate"
      ></rk-button>
    }
  </div>
</div>
